import { COUNTRY_CODES, type SignUpMetadata } from '@noconflict/contracts';
import { z } from 'zod';
import { validationMessage } from '../../../shared/i18n/zod';
import { credentialsSchema } from '../sign-in-form/model';

const name = (required: 'firstNameRequired' | 'lastNameRequired') =>
  z.string().trim().min(1, validationMessage(required)).max(80, validationMessage('nameMax'));

/**
 * Sign-up values. Names follow the contract's `personNameSchema` (trimmed, 1–80) with catalogue messages;
 * `shared/i18n/zod.test.ts` keeps the two in step.
 */
export const signUpSchema = credentialsSchema.extend({
  firstName: name('firstNameRequired'),
  lastName: name('lastNameRequired'),
  country: z.enum(COUNTRY_CODES, validationMessage('countryRequired')),
});
export type SignUpInput = z.input<typeof signUpSchema>;
export type SignUpValues = z.output<typeof signUpSchema>;
export type SignUpSubmit = (values: SignUpValues) => Promise<{ error: string | null }>;

/** The `supabase.auth.signUp` argument: the signup trigger reads the names and country from `options.data`. */
export function toSignUpRequest(values: SignUpValues) {
  const data: SignUpMetadata = {
    first_name: values.firstName,
    last_name: values.lastName,
    country: values.country,
  };
  return { email: values.email, password: values.password, options: { data } };
}
